<template>
  <!-- モーダルウィンドウ -->
  <div class="c-modal c-modal--style-settings" :class="{ 'is-active': isOpen }">
    <div class="c-modal__bg" @click="$emit('close')"></div>
    <div class="c-modal__content">
      <div class="c-modal__close" @click="$emit('close')">
        <div class="c-icon c-icon--white u-wh14">
          <Icon name="close" :size="14" color="#fff" />
        </div>
      </div>
      <button
        class="c-btn c-btn--modal c-btn--blue u-w140 u-h34 u-fs14 p-style-dialog__preview-btn"
        :class="{ 'is-preview-active': isPreviewShown }"
        type="button"
        @click="$emit('toggle-preview')"
      >
        <p class="c-btn__text">{{ isPreviewShown ? 'プレビュー中' : 'プレビュー' }}</p>
      </button>
      <div class="c-modal__inner">
        <div class="c-modal__title">プレオプトインスタイル設定</div>
        <div class="c-modal__data">
          <!-- 位置 -->
          <section class="p-style-dialog__section">
            <div class="p-style-dialog__section-header">
              <h4 class="p-style-dialog__section-title">位置</h4>
              <button
                type="button"
                class="p-style-dialog__section-reset"
                title="この設定を初期値に戻す"
                @click="resetSection(sectionFields.position)"
              ><Icon name="refresh" :size="15" /></button>
            </div>
            <div class="p-style-dialog__position-columns">
              <!-- PC 用 -->
              <div class="p-style-dialog__position-column">
                <h5 class="p-style-dialog__subsection-title">PC用</h5>
                <div class="p-style-dialog__row">
                  <div class="p-style-dialog__label">上下</div>
                  <div class="p-style-dialog__field">
                    <div class="c-radio">
                      <ul class="c-radio-list p-style-dialog__radio-list">
                        <li class="c-radio-list__item">
                          <label class="c-radio__label">
                            <input v-model="vertical" type="radio" value="top" />
                            <div class="c-radio__item">
                              <div class="c-radio__box"></div>
                              <div class="c-radio__box-label">上</div>
                            </div>
                          </label>
                        </li>
                        <li class="c-radio-list__item">
                          <label class="c-radio__label">
                            <input v-model="vertical" type="radio" value="bottom" />
                            <div class="c-radio__item">
                              <div class="c-radio__box"></div>
                              <div class="c-radio__box-label">下</div>
                            </div>
                          </label>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="p-style-dialog__row">
                  <div class="p-style-dialog__label">左右</div>
                  <div class="p-style-dialog__field">
                    <div class="c-radio">
                      <ul class="c-radio-list p-style-dialog__radio-list">
                        <li class="c-radio-list__item">
                          <label class="c-radio__label">
                            <input v-model="horizontal" type="radio" value="left" />
                            <div class="c-radio__item">
                              <div class="c-radio__box"></div>
                              <div class="c-radio__box-label">左</div>
                            </div>
                          </label>
                        </li>
                        <li class="c-radio-list__item">
                          <label class="c-radio__label">
                            <input v-model="horizontal" type="radio" value="center" />
                            <div class="c-radio__item">
                              <div class="c-radio__box"></div>
                              <div class="c-radio__box-label">中央</div>
                            </div>
                          </label>
                        </li>
                        <li class="c-radio-list__item">
                          <label class="c-radio__label">
                            <input v-model="horizontal" type="radio" value="right" />
                            <div class="c-radio__item">
                              <div class="c-radio__box"></div>
                              <div class="c-radio__box-label">右</div>
                            </div>
                          </label>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="p-style-dialog__row">
                  <div class="p-style-dialog__label">z-index</div>
                  <div class="p-style-dialog__field">
                    <InputNumberSpinner :value="getRaw('zIndex')" :step="1" @input="setRaw('zIndex', String($event))" />
                  </div>
                </div>
              </div>
              <!-- スマホ用(画面の横幅が430px以下) -->
              <div class="p-style-dialog__position-column">
                <h5 class="p-style-dialog__subsection-title">スマホ用(画面の横幅が430px以下)</h5>
                <div class="p-style-dialog__row">
                  <div class="p-style-dialog__label">上下</div>
                  <div class="p-style-dialog__field">
                    <div class="c-radio">
                      <ul class="c-radio-list p-style-dialog__radio-list">
                        <li class="c-radio-list__item">
                          <label class="c-radio__label">
                            <input v-model="spVertical" type="radio" value="top" />
                            <div class="c-radio__item">
                              <div class="c-radio__box"></div>
                              <div class="c-radio__box-label">上</div>
                            </div>
                          </label>
                        </li>
                        <li class="c-radio-list__item">
                          <label class="c-radio__label">
                            <input v-model="spVertical" type="radio" value="bottom" />
                            <div class="c-radio__item">
                              <div class="c-radio__box"></div>
                              <div class="c-radio__box-label">下</div>
                            </div>
                          </label>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
                <div class="p-style-dialog__row">
                  <div class="p-style-dialog__label">左右</div>
                  <div class="p-style-dialog__field">
                    <span class="p-style-dialog__note">※画面幅いっぱいに表示されます</span>
                  </div>
                </div>
                <div class="p-style-dialog__row">
                  <div class="p-style-dialog__label">z-index</div>
                  <div class="p-style-dialog__field">
                    <InputNumberSpinner :value="getRaw('spZIndex')" :step="1" @input="setRaw('spZIndex', String($event))" />
                  </div>
                </div>
              </div>
            </div>
          </section>

          <!-- 全体 -->
          <section class="p-style-dialog__section">
            <div class="p-style-dialog__section-header">
              <h4 class="p-style-dialog__section-title">外観</h4>
              <button
                type="button"
                class="p-style-dialog__section-reset"
                title="この設定を初期値に戻す"
                @click="resetSection(sectionFields.container)"
              ><Icon name="refresh" :size="15" /></button>
            </div>
            <div class="p-style-dialog__row">
              <div class="p-style-dialog__label">横幅</div>
              <div class="p-style-dialog__field">
                <InputNumberSpinner :value="getPx('width')" :step="10" @input="setPx('width', $event)" />
                <span class="p-style-dialog__unit">px</span>
              </div>
            </div>
            <div class="p-style-dialog__row">
              <div class="p-style-dialog__label">背景色</div>
              <div class="p-style-dialog__field">
                <InputColor :value="getRaw('backgroundColor')" placeholder="#FFFFFF" @input="setRaw('backgroundColor', $event)" />
              </div>
            </div>
            <div class="p-style-dialog__row">
              <div class="p-style-dialog__label">内側の余白</div>
              <div class="p-style-dialog__field">
                <InputNumberSpinner :value="getPx('padding')" :step="1" @input="setPx('padding', $event)" />
                <span class="p-style-dialog__unit">px</span>
              </div>
            </div>
            <div class="p-style-dialog__row">
              <div class="p-style-dialog__label">角の丸み</div>
              <div class="p-style-dialog__field">
                <InputNumberSpinner :value="getPx('borderRadius')" :step="1" @input="setPx('borderRadius', $event)" />
                <span class="p-style-dialog__unit">px</span>
              </div>
            </div>
            <div class="p-style-dialog__row">
              <div class="p-style-dialog__label">枠の影</div>
              <div class="p-style-dialog__field">
                <div class="c-radio">
                  <ul class="c-radio-list p-style-dialog__radio-list">
                    <li class="c-radio-list__item">
                      <label class="c-radio__label">
                        <input v-model="hasBoxShadow" type="radio" :value="true" />
                        <div class="c-radio__item">
                          <div class="c-radio__box"></div>
                          <div class="c-radio__box-label">あり</div>
                        </div>
                      </label>
                    </li>
                    <li class="c-radio-list__item">
                      <label class="c-radio__label">
                        <input v-model="hasBoxShadow" type="radio" :value="false" />
                        <div class="c-radio__item">
                          <div class="c-radio__box"></div>
                          <div class="c-radio__box-label">なし</div>
                        </div>
                      </label>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="p-style-dialog__row">
              <div class="p-style-dialog__label">ボーダー幅</div>
              <div class="p-style-dialog__field">
                <InputNumberSpinner :value="getPx('borderWidth')" :step="1" @input="onBorderWidthChange('borderWidth', 'borderStyle', 'borderColor', $event)" />
                <span class="p-style-dialog__unit">px</span>
              </div>
            </div>
            <div v-if="getPx('borderWidth') >= 1" class="p-style-dialog__row">
              <div class="p-style-dialog__label">ボーダー色</div>
              <div class="p-style-dialog__field">
                <InputColor :value="getRaw('borderColor')" placeholder="transparent" @input="setRaw('borderColor', $event)" />
              </div>
            </div>
            <div v-if="getPx('borderWidth') >= 1" class="p-style-dialog__row">
              <div class="p-style-dialog__label">ボーダースタイル</div>
              <div class="p-style-dialog__field">
                <div class="c-radio">
                  <ul class="c-radio-list p-style-dialog__radio-list">
                    <li class="c-radio-list__item">
                      <label class="c-radio__label">
                        <input type="radio" :checked="getRaw('borderStyle') === 'solid'" @change="setRaw('borderStyle', 'solid')" />
                        <div class="c-radio__item">
                          <div class="c-radio__box"></div>
                          <div class="c-radio__box-label">実線</div>
                        </div>
                      </label>
                    </li>
                    <li class="c-radio-list__item">
                      <label class="c-radio__label">
                        <input type="radio" :checked="getRaw('borderStyle') === 'dashed'" @change="setRaw('borderStyle', 'dashed')" />
                        <div class="c-radio__item">
                          <div class="c-radio__box"></div>
                          <div class="c-radio__box-label">破線</div>
                        </div>
                      </label>
                    </li>
                    <li class="c-radio-list__item">
                      <label class="c-radio__label">
                        <input type="radio" :checked="getRaw('borderStyle') === 'dotted'" @change="setRaw('borderStyle', 'dotted')" />
                        <div class="c-radio__item">
                          <div class="c-radio__box"></div>
                          <div class="c-radio__box-label">点線</div>
                        </div>
                      </label>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          <!-- アイコン(iconUrl 設定時のみ表示) -->
          <section v-if="hasIcon" class="p-style-dialog__section">
            <div class="p-style-dialog__section-header">
              <h4 class="p-style-dialog__section-title">アイコン</h4>
              <button
                type="button"
                class="p-style-dialog__section-reset"
                title="この設定を初期値に戻す"
                @click="resetSection(sectionFields.icon)"
              ><Icon name="refresh" :size="15" /></button>
            </div>
            <div class="p-style-dialog__row">
              <div class="p-style-dialog__label">アイコンサイズ</div>
              <div class="p-style-dialog__field">
                <InputNumberSpinner :value="getPx('iconSize')" :step="1" @input="setPx('iconSize', $event)" />
                <span class="p-style-dialog__unit">px</span>
              </div>
            </div>
            <div class="p-style-dialog__row">
              <div class="p-style-dialog__label">角の丸み</div>
              <div class="p-style-dialog__field">
                <InputNumberSpinner :value="getPx('iconBorderRadius')" :step="1" @input="setPx('iconBorderRadius', $event)" />
                <span class="p-style-dialog__unit">px</span>
              </div>
            </div>
            <div class="p-style-dialog__row">
              <div class="p-style-dialog__label">テキストとの余白</div>
              <div class="p-style-dialog__field">
                <InputNumberSpinner :value="getPx('gap')" :step="1" @input="setPx('gap', $event)" />
                <span class="p-style-dialog__unit">px</span>
              </div>
            </div>
            <div class="p-style-dialog__row">
              <div class="p-style-dialog__label">ボーダー幅</div>
              <div class="p-style-dialog__field">
                <InputNumberSpinner :value="getPx('iconBorderWidth')" :step="1" @input="onBorderWidthChange('iconBorderWidth', 'iconBorderStyle', 'iconBorderColor', $event)" />
                <span class="p-style-dialog__unit">px</span>
              </div>
            </div>
            <div v-if="getPx('iconBorderWidth') >= 1" class="p-style-dialog__row">
              <div class="p-style-dialog__label">ボーダー色</div>
              <div class="p-style-dialog__field">
                <InputColor :value="getRaw('iconBorderColor')" placeholder="transparent" @input="setRaw('iconBorderColor', $event)" />
              </div>
            </div>
            <div v-if="getPx('iconBorderWidth') >= 1" class="p-style-dialog__row">
              <div class="p-style-dialog__label">ボーダースタイル</div>
              <div class="p-style-dialog__field">
                <div class="c-radio">
                  <ul class="c-radio-list p-style-dialog__radio-list">
                    <li class="c-radio-list__item">
                      <label class="c-radio__label">
                        <input type="radio" :checked="getRaw('iconBorderStyle') === 'solid'" @change="setRaw('iconBorderStyle', 'solid')" />
                        <div class="c-radio__item">
                          <div class="c-radio__box"></div>
                          <div class="c-radio__box-label">実線</div>
                        </div>
                      </label>
                    </li>
                    <li class="c-radio-list__item">
                      <label class="c-radio__label">
                        <input type="radio" :checked="getRaw('iconBorderStyle') === 'dashed'" @change="setRaw('iconBorderStyle', 'dashed')" />
                        <div class="c-radio__item">
                          <div class="c-radio__box"></div>
                          <div class="c-radio__box-label">破線</div>
                        </div>
                      </label>
                    </li>
                    <li class="c-radio-list__item">
                      <label class="c-radio__label">
                        <input type="radio" :checked="getRaw('iconBorderStyle') === 'dotted'" @change="setRaw('iconBorderStyle', 'dotted')" />
                        <div class="c-radio__item">
                          <div class="c-radio__box"></div>
                          <div class="c-radio__box-label">点線</div>
                        </div>
                      </label>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          <div class="p-style-dialog__grid">
            <!-- タイトル -->
            <section class="p-style-dialog__section">
              <div class="p-style-dialog__section-header">
                <h4 class="p-style-dialog__section-title">タイトル</h4>
                <button
                  type="button"
                  class="p-style-dialog__section-reset"
                  title="この設定を初期値に戻す"
                  @click="resetSection(sectionFields.title)"
                ><Icon name="refresh" :size="15" /></button>
              </div>
              <div class="p-style-dialog__row">
                <div class="p-style-dialog__label">文字の色</div>
                <div class="p-style-dialog__field">
                  <InputColor :value="getRaw('titleColor')" placeholder="#333333" @input="setRaw('titleColor', $event)" />
                </div>
              </div>
              <div class="p-style-dialog__row">
                <div class="p-style-dialog__label">文字の大きさ</div>
                <div class="p-style-dialog__field">
                  <InputNumberSpinner :value="getPx('titleFontSize')" :step="1" @input="setPx('titleFontSize', $event)" />
                  <span class="p-style-dialog__unit">px</span>
                </div>
              </div>
              <div class="p-style-dialog__row">
                <div class="p-style-dialog__label">文字の太さ</div>
                <div class="p-style-dialog__field">
                  <div class="c-radio">
                    <ul class="c-radio-list p-style-dialog__radio-list">
                      <li class="c-radio-list__item">
                        <label class="c-radio__label">
                          <input type="radio" :checked="getRaw('titleFontWeight') === 'normal'" @change="setRaw('titleFontWeight', 'normal')" />
                          <div class="c-radio__item">
                            <div class="c-radio__box"></div>
                            <div class="c-radio__box-label">標準</div>
                          </div>
                        </label>
                      </li>
                      <li class="c-radio-list__item">
                        <label class="c-radio__label">
                          <input type="radio" :checked="getRaw('titleFontWeight') === 'bold'" @change="setRaw('titleFontWeight', 'bold')" />
                          <div class="c-radio__item">
                            <div class="c-radio__box"></div>
                            <div class="c-radio__box-label">太字</div>
                          </div>
                        </label>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>

            <!-- 説明文 -->
            <section class="p-style-dialog__section">
              <div class="p-style-dialog__section-header">
                <h4 class="p-style-dialog__section-title">説明文</h4>
                <button
                  type="button"
                  class="p-style-dialog__section-reset"
                  title="この設定を初期値に戻す"
                  @click="resetSection(sectionFields.description)"
                ><Icon name="refresh" :size="15" /></button>
              </div>
              <div class="p-style-dialog__row">
                <div class="p-style-dialog__label">文字の色</div>
                <div class="p-style-dialog__field">
                  <InputColor :value="getRaw('descriptionColor')" placeholder="#888888" @input="setRaw('descriptionColor', $event)" />
                </div>
              </div>
              <div class="p-style-dialog__row">
                <div class="p-style-dialog__label">文字の大きさ</div>
                <div class="p-style-dialog__field">
                  <InputNumberSpinner :value="getPx('descriptionFontSize')" :step="1" @input="setPx('descriptionFontSize', $event)" />
                  <span class="p-style-dialog__unit">px</span>
                </div>
              </div>
              <div class="p-style-dialog__row">
                <div class="p-style-dialog__label">文字の太さ</div>
                <div class="p-style-dialog__field">
                  <div class="c-radio">
                    <ul class="c-radio-list p-style-dialog__radio-list">
                      <li class="c-radio-list__item">
                        <label class="c-radio__label">
                          <input type="radio" :checked="getRaw('descriptionFontWeight') === 'normal'" @change="setRaw('descriptionFontWeight', 'normal')" />
                          <div class="c-radio__item">
                            <div class="c-radio__box"></div>
                            <div class="c-radio__box-label">標準</div>
                          </div>
                        </label>
                      </li>
                      <li class="c-radio-list__item">
                        <label class="c-radio__label">
                          <input type="radio" :checked="getRaw('descriptionFontWeight') === 'bold'" @change="setRaw('descriptionFontWeight', 'bold')" />
                          <div class="c-radio__item">
                            <div class="c-radio__box"></div>
                            <div class="c-radio__box-label">太字</div>
                          </div>
                        </label>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <!-- ボタン共通 -->
          <section class="p-style-dialog__section">
            <div class="p-style-dialog__section-header">
              <h4 class="p-style-dialog__section-title">ボタン共通</h4>
              <button
                type="button"
                class="p-style-dialog__section-reset"
                title="この設定を初期値に戻す"
                @click="resetSection(sectionFields.buttonsCommon)"
              ><Icon name="refresh" :size="15" /></button>
            </div>
            <div class="p-style-dialog__row">
              <div class="p-style-dialog__label">位置</div>
              <div class="p-style-dialog__field">
                <div class="c-radio">
                  <ul class="c-radio-list p-style-dialog__radio-list">
                    <li class="c-radio-list__item">
                      <label class="c-radio__label">
                        <input type="radio" :checked="getRaw('buttonsJustifyContent') === 'flex-start'" @change="setRaw('buttonsJustifyContent', 'flex-start')" />
                        <div class="c-radio__item">
                          <div class="c-radio__box"></div>
                          <div class="c-radio__box-label">左寄せ</div>
                        </div>
                      </label>
                    </li>
                    <li class="c-radio-list__item">
                      <label class="c-radio__label">
                        <input type="radio" :checked="getRaw('buttonsJustifyContent') === 'center'" @change="setRaw('buttonsJustifyContent', 'center')" />
                        <div class="c-radio__item">
                          <div class="c-radio__box"></div>
                          <div class="c-radio__box-label">中央</div>
                        </div>
                      </label>
                    </li>
                    <li class="c-radio-list__item">
                      <label class="c-radio__label">
                        <input type="radio" :checked="getRaw('buttonsJustifyContent') === 'flex-end'" @change="setRaw('buttonsJustifyContent', 'flex-end')" />
                        <div class="c-radio__item">
                          <div class="c-radio__box"></div>
                          <div class="c-radio__box-label">右寄せ</div>
                        </div>
                      </label>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div class="p-style-dialog__row">
              <div class="p-style-dialog__label">上の余白</div>
              <div class="p-style-dialog__field">
                <InputNumberSpinner :value="getPx('buttonsMarginTop')" :step="1" @input="setPx('buttonsMarginTop', $event)" />
                <span class="p-style-dialog__unit">px</span>
              </div>
            </div>
            <div class="p-style-dialog__row">
              <div class="p-style-dialog__label">ボタン間の余白</div>
              <div class="p-style-dialog__field">
                <InputNumberSpinner :value="getPx('buttonsGap')" :step="1" @input="setPx('buttonsGap', $event)" />
                <span class="p-style-dialog__unit">px</span>
              </div>
            </div>
          </section>

          <div class="p-style-dialog__grid">
            <!-- 拒否ボタン -->
            <section class="p-style-dialog__section">
              <div class="p-style-dialog__section-header">
                <h4 class="p-style-dialog__section-title">拒否ボタン</h4>
                <button
                  type="button"
                  class="p-style-dialog__section-reset"
                  title="この設定を初期値に戻す"
                  @click="resetSection(sectionFields.buttonDeny)"
                ><Icon name="refresh" :size="15" /></button>
              </div>
              <h5 class="p-style-dialog__subsection-title">ボタンの外観</h5>
              <div class="p-style-dialog__row">
                <div class="p-style-dialog__label">背景色</div>
                <div class="p-style-dialog__field">
                  <InputColor :value="getRaw('buttonDenyBackgroundColor')" placeholder="#F5F5F5" @input="setRaw('buttonDenyBackgroundColor', $event)" />
                </div>
              </div>
              <div class="p-style-dialog__row">
                <div class="p-style-dialog__label">内側の余白</div>
                <div class="p-style-dialog__field">
                  <InputNumberSpinner :value="getPx('buttonDenyPadding')" :step="1" @input="setPx('buttonDenyPadding', $event)" />
                  <span class="p-style-dialog__unit">px</span>
                </div>
              </div>
              <div class="p-style-dialog__row">
                <div class="p-style-dialog__label">角の丸み</div>
                <div class="p-style-dialog__field">
                  <InputNumberSpinner :value="getPx('buttonDenyBorderRadius')" :step="1" @input="setPx('buttonDenyBorderRadius', $event)" />
                  <span class="p-style-dialog__unit">px</span>
                </div>
              </div>
              <div class="p-style-dialog__row">
                <div class="p-style-dialog__label">ボタンの影</div>
                <div class="p-style-dialog__field">
                  <div class="c-radio">
                    <ul class="c-radio-list p-style-dialog__radio-list">
                      <li class="c-radio-list__item">
                        <label class="c-radio__label">
                          <input v-model="hasButtonDenyBoxShadow" type="radio" :value="true" />
                          <div class="c-radio__item">
                            <div class="c-radio__box"></div>
                            <div class="c-radio__box-label">あり</div>
                          </div>
                        </label>
                      </li>
                      <li class="c-radio-list__item">
                        <label class="c-radio__label">
                          <input v-model="hasButtonDenyBoxShadow" type="radio" :value="false" />
                          <div class="c-radio__item">
                            <div class="c-radio__box"></div>
                            <div class="c-radio__box-label">なし</div>
                          </div>
                        </label>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="p-style-dialog__row">
                <div class="p-style-dialog__label">ボーダー幅</div>
                <div class="p-style-dialog__field">
                  <InputNumberSpinner :value="getPx('buttonDenyBorderWidth')" :step="1" @input="onBorderWidthChange('buttonDenyBorderWidth', 'buttonDenyBorderStyle', 'buttonDenyBorderColor', $event)" />
                  <span class="p-style-dialog__unit">px</span>
                </div>
              </div>
              <div v-if="getPx('buttonDenyBorderWidth') >= 1" class="p-style-dialog__row">
                <div class="p-style-dialog__label">ボーダー色</div>
                <div class="p-style-dialog__field">
                  <InputColor :value="getRaw('buttonDenyBorderColor')" placeholder="transparent" @input="setRaw('buttonDenyBorderColor', $event)" />
                </div>
              </div>
              <div v-if="getPx('buttonDenyBorderWidth') >= 1" class="p-style-dialog__row">
                <div class="p-style-dialog__label">ボーダースタイル</div>
                <div class="p-style-dialog__field">
                  <div class="c-radio">
                    <ul class="c-radio-list p-style-dialog__radio-list">
                      <li class="c-radio-list__item">
                        <label class="c-radio__label">
                          <input type="radio" :checked="getRaw('buttonDenyBorderStyle') === 'solid'" @change="setRaw('buttonDenyBorderStyle', 'solid')" />
                          <div class="c-radio__item">
                            <div class="c-radio__box"></div>
                            <div class="c-radio__box-label">実線</div>
                          </div>
                        </label>
                      </li>
                      <li class="c-radio-list__item">
                        <label class="c-radio__label">
                          <input type="radio" :checked="getRaw('buttonDenyBorderStyle') === 'dashed'" @change="setRaw('buttonDenyBorderStyle', 'dashed')" />
                          <div class="c-radio__item">
                            <div class="c-radio__box"></div>
                            <div class="c-radio__box-label">破線</div>
                          </div>
                        </label>
                      </li>
                      <li class="c-radio-list__item">
                        <label class="c-radio__label">
                          <input type="radio" :checked="getRaw('buttonDenyBorderStyle') === 'dotted'" @change="setRaw('buttonDenyBorderStyle', 'dotted')" />
                          <div class="c-radio__item">
                            <div class="c-radio__box"></div>
                            <div class="c-radio__box-label">点線</div>
                          </div>
                        </label>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <h5 class="p-style-dialog__subsection-title">ボタンのラベル</h5>
              <div class="p-style-dialog__row">
                <div class="p-style-dialog__label">文字の色</div>
                <div class="p-style-dialog__field">
                  <InputColor :value="getRaw('buttonDenyColor')" placeholder="#737373" @input="setRaw('buttonDenyColor', $event)" />
                </div>
              </div>
              <div class="p-style-dialog__row">
                <div class="p-style-dialog__label">文字の大きさ</div>
                <div class="p-style-dialog__field">
                  <InputNumberSpinner :value="getPx('buttonDenyFontSize')" :step="1" @input="setPx('buttonDenyFontSize', $event)" />
                  <span class="p-style-dialog__unit">px</span>
                </div>
              </div>
              <div class="p-style-dialog__row">
                <div class="p-style-dialog__label">文字の太さ</div>
                <div class="p-style-dialog__field">
                  <div class="c-radio">
                    <ul class="c-radio-list p-style-dialog__radio-list">
                      <li class="c-radio-list__item">
                        <label class="c-radio__label">
                          <input type="radio" :checked="getRaw('buttonDenyFontWeight') === 'normal'" @change="setRaw('buttonDenyFontWeight', 'normal')" />
                          <div class="c-radio__item">
                            <div class="c-radio__box"></div>
                            <div class="c-radio__box-label">標準</div>
                          </div>
                        </label>
                      </li>
                      <li class="c-radio-list__item">
                        <label class="c-radio__label">
                          <input type="radio" :checked="getRaw('buttonDenyFontWeight') === 'bold'" @change="setRaw('buttonDenyFontWeight', 'bold')" />
                          <div class="c-radio__item">
                            <div class="c-radio__box"></div>
                            <div class="c-radio__box-label">太字</div>
                          </div>
                        </label>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>

            <!-- 許可ボタン -->
            <section class="p-style-dialog__section">
              <div class="p-style-dialog__section-header">
                <h4 class="p-style-dialog__section-title">許可ボタン</h4>
                <button
                  type="button"
                  class="p-style-dialog__section-reset"
                  title="この設定を初期値に戻す"
                  @click="resetSection(sectionFields.buttonAllow)"
                ><Icon name="refresh" :size="15" /></button>
              </div>
              <h5 class="p-style-dialog__subsection-title">ボタンの外観</h5>
              <div class="p-style-dialog__row">
                <div class="p-style-dialog__label">背景色</div>
                <div class="p-style-dialog__field">
                  <InputColor :value="getRaw('buttonAllowBackgroundColor')" placeholder="#333333" @input="setRaw('buttonAllowBackgroundColor', $event)" />
                </div>
              </div>
              <div class="p-style-dialog__row">
                <div class="p-style-dialog__label">内側の余白</div>
                <div class="p-style-dialog__field">
                  <InputNumberSpinner :value="getPx('buttonAllowPadding')" :step="1" @input="setPx('buttonAllowPadding', $event)" />
                  <span class="p-style-dialog__unit">px</span>
                </div>
              </div>
              <div class="p-style-dialog__row">
                <div class="p-style-dialog__label">角の丸み</div>
                <div class="p-style-dialog__field">
                  <InputNumberSpinner :value="getPx('buttonAllowBorderRadius')" :step="1" @input="setPx('buttonAllowBorderRadius', $event)" />
                  <span class="p-style-dialog__unit">px</span>
                </div>
              </div>
              <div class="p-style-dialog__row">
                <div class="p-style-dialog__label">ボタンの影</div>
                <div class="p-style-dialog__field">
                  <div class="c-radio">
                    <ul class="c-radio-list p-style-dialog__radio-list">
                      <li class="c-radio-list__item">
                        <label class="c-radio__label">
                          <input v-model="hasButtonAllowBoxShadow" type="radio" :value="true" />
                          <div class="c-radio__item">
                            <div class="c-radio__box"></div>
                            <div class="c-radio__box-label">あり</div>
                          </div>
                        </label>
                      </li>
                      <li class="c-radio-list__item">
                        <label class="c-radio__label">
                          <input v-model="hasButtonAllowBoxShadow" type="radio" :value="false" />
                          <div class="c-radio__item">
                            <div class="c-radio__box"></div>
                            <div class="c-radio__box-label">なし</div>
                          </div>
                        </label>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="p-style-dialog__row">
                <div class="p-style-dialog__label">ボーダー幅</div>
                <div class="p-style-dialog__field">
                  <InputNumberSpinner :value="getPx('buttonAllowBorderWidth')" :step="1" @input="onBorderWidthChange('buttonAllowBorderWidth', 'buttonAllowBorderStyle', 'buttonAllowBorderColor', $event)" />
                  <span class="p-style-dialog__unit">px</span>
                </div>
              </div>
              <div v-if="getPx('buttonAllowBorderWidth') >= 1" class="p-style-dialog__row">
                <div class="p-style-dialog__label">ボーダー色</div>
                <div class="p-style-dialog__field">
                  <InputColor :value="getRaw('buttonAllowBorderColor')" placeholder="transparent" @input="setRaw('buttonAllowBorderColor', $event)" />
                </div>
              </div>
              <div v-if="getPx('buttonAllowBorderWidth') >= 1" class="p-style-dialog__row">
                <div class="p-style-dialog__label">ボーダースタイル</div>
                <div class="p-style-dialog__field">
                  <div class="c-radio">
                    <ul class="c-radio-list p-style-dialog__radio-list">
                      <li class="c-radio-list__item">
                        <label class="c-radio__label">
                          <input type="radio" :checked="getRaw('buttonAllowBorderStyle') === 'solid'" @change="setRaw('buttonAllowBorderStyle', 'solid')" />
                          <div class="c-radio__item">
                            <div class="c-radio__box"></div>
                            <div class="c-radio__box-label">実線</div>
                          </div>
                        </label>
                      </li>
                      <li class="c-radio-list__item">
                        <label class="c-radio__label">
                          <input type="radio" :checked="getRaw('buttonAllowBorderStyle') === 'dashed'" @change="setRaw('buttonAllowBorderStyle', 'dashed')" />
                          <div class="c-radio__item">
                            <div class="c-radio__box"></div>
                            <div class="c-radio__box-label">破線</div>
                          </div>
                        </label>
                      </li>
                      <li class="c-radio-list__item">
                        <label class="c-radio__label">
                          <input type="radio" :checked="getRaw('buttonAllowBorderStyle') === 'dotted'" @change="setRaw('buttonAllowBorderStyle', 'dotted')" />
                          <div class="c-radio__item">
                            <div class="c-radio__box"></div>
                            <div class="c-radio__box-label">点線</div>
                          </div>
                        </label>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <h5 class="p-style-dialog__subsection-title">ボタンのラベル</h5>
              <div class="p-style-dialog__row">
                <div class="p-style-dialog__label">文字の色</div>
                <div class="p-style-dialog__field">
                  <InputColor :value="getRaw('buttonAllowColor')" placeholder="#FFFFFF" @input="setRaw('buttonAllowColor', $event)" />
                </div>
              </div>
              <div class="p-style-dialog__row">
                <div class="p-style-dialog__label">文字の大きさ</div>
                <div class="p-style-dialog__field">
                  <InputNumberSpinner :value="getPx('buttonAllowFontSize')" :step="1" @input="setPx('buttonAllowFontSize', $event)" />
                  <span class="p-style-dialog__unit">px</span>
                </div>
              </div>
              <div class="p-style-dialog__row">
                <div class="p-style-dialog__label">文字の太さ</div>
                <div class="p-style-dialog__field">
                  <div class="c-radio">
                    <ul class="c-radio-list p-style-dialog__radio-list">
                      <li class="c-radio-list__item">
                        <label class="c-radio__label">
                          <input type="radio" :checked="getRaw('buttonAllowFontWeight') === 'normal'" @change="setRaw('buttonAllowFontWeight', 'normal')" />
                          <div class="c-radio__item">
                            <div class="c-radio__box"></div>
                            <div class="c-radio__box-label">標準</div>
                          </div>
                        </label>
                      </li>
                      <li class="c-radio-list__item">
                        <label class="c-radio__label">
                          <input type="radio" :checked="getRaw('buttonAllowFontWeight') === 'bold'" @change="setRaw('buttonAllowFontWeight', 'bold')" />
                          <div class="c-radio__item">
                            <div class="c-radio__box"></div>
                            <div class="c-radio__box-label">太字</div>
                          </div>
                        </label>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </div>
        <div class="c-modal__btns">
          <button class="c-btn c-btn--modal c-btn--gray u-w140 u-h34 u-fs14" type="button" @click="onReset">
            <p class="c-btn__text">初期値に戻す</p>
          </button>
          <button class="c-btn c-btn--modal c-btn--blue u-w140 u-h34 u-fs14" type="button" @click="$emit('close')">
            <p class="c-btn__text">閉じる</p>
          </button>
        </div>
      </div>
    </div>
    <!-- リセット確認モーダル(共通の ControlModal を利用) -->
    <ControlModal
      classes="c-modal--reset-confirm"
      :is-active="isResetConfirmOpen"
      title="スタイル設定のリセット"
      body="スタイルを初期値に戻してよろしいですか？"
      cancel-button-label="キャンセル"
      enter-button-label="リセット"
      :on-cancel-click="closeResetConfirm"
      :on-close-click="closeResetConfirm"
      :on-enter-click="confirmReset"
    />
  </div>
  <!-- /モーダルウィンドウ -->
</template>

<script>
import ControlModal from './ControlModal.vue';
import Icon from '../atoms/Icon.vue';
import InputNumberSpinner from '../atoms/InputNumberSpinner.vue';
import InputColor from '../atoms/InputColor.vue';
// SDK CSS のデフォルト値(--pushone-preoptin-dialog-v2-* と同じ値)
// SDK: pushone-javascript-sdk/browserpush/public/css/pushone-preoptin-dialog-v2.css
const STYLE_DEFAULTS = {
  width: '430px',
  zIndex: '9999',
  spZIndex: '9999',
  spTop: 'auto',
  spBottom: '0px',
  borderRadius: '8px',
  borderWidth: '0px',
  borderStyle: 'solid',
  borderColor: 'transparent',
  backgroundColor: '#FFFFFF',
  padding: '12px',
  gap: '8px',
  boxShadow: '0 1px 3px rgba(0, 0, 0, .12), 0 1px 2px rgba(0, 0, 0, .24)',
  titleColor: '#333333',
  titleFontSize: '15px',
  titleFontWeight: 'bold',
  descriptionColor: '#888888',
  descriptionFontSize: '13px',
  descriptionFontWeight: 'normal',
  iconSize: '64px',
  iconBorderRadius: '4px',
  iconBorderWidth: '0px',
  iconBorderStyle: 'solid',
  iconBorderColor: 'transparent',
  buttonsJustifyContent: 'flex-end',
  buttonsMarginTop: '12px',
  buttonsGap: '8px',
  buttonDenyBackgroundColor: '#F5F5F5',
  buttonDenyColor: '#737373',
  buttonDenyFontSize: '12px',
  buttonDenyFontWeight: 'normal',
  buttonDenyBorderWidth: '0px',
  buttonDenyBorderStyle: 'solid',
  buttonDenyBorderColor: 'transparent',
  buttonDenyBorderRadius: '4px',
  buttonDenyPadding: '8px',
  buttonDenyBoxShadow: 'none',
  buttonAllowBackgroundColor: '#333333',
  buttonAllowColor: '#FFFFFF',
  buttonAllowFontSize: '12px',
  buttonAllowFontWeight: 'bold',
  buttonAllowBorderWidth: '0px',
  buttonAllowBorderStyle: 'solid',
  buttonAllowBorderColor: 'transparent',
  buttonAllowBorderRadius: '4px',
  buttonAllowPadding: '8px',
  buttonAllowBoxShadow: 'none',
};
// 常に出力対象とする位置系フィールド(初期値一致でも style から削除しない)
const POSITION_FIELDS = ['top', 'bottom', 'left', 'right'];

export default {
  components: { ControlModal, InputNumberSpinner, InputColor, Icon },
  props: {
    isOpen: {
      type: Boolean,
      default: false,
    },
    styleData: {
      type: Object,
      required: true,
    },
    isPreviewShown: {
      type: Boolean,
      default: false,
    },
    hasIcon: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["close","toggle-preview","update:styleData"],
  data() {
    return {
      isResetConfirmOpen: false,
      // ボーダー幅を 0 にした時に色/スタイルを styleData から削除するが、
      // 次に 1 以上へ戻した時に前回値を復元するための一時保管
      borderStash: {},
      sectionFields: {
        position: ['top', 'right', 'bottom', 'left', 'translate', 'zIndex', 'spTop', 'spBottom', 'spZIndex'],
        container: ['width', 'backgroundColor', 'padding', 'borderRadius', 'boxShadow', 'borderWidth', 'borderStyle', 'borderColor'],
        icon: ['iconSize', 'iconBorderRadius', 'gap', 'iconBorderWidth', 'iconBorderStyle', 'iconBorderColor'],
        title: ['titleColor', 'titleFontSize', 'titleFontWeight'],
        description: ['descriptionColor', 'descriptionFontSize', 'descriptionFontWeight'],
        buttonsCommon: ['buttonsJustifyContent', 'buttonsMarginTop', 'buttonsGap'],
        buttonDeny: [
          'buttonDenyBackgroundColor', 'buttonDenyColor',
          'buttonDenyFontSize', 'buttonDenyFontWeight',
          'buttonDenyBorderWidth', 'buttonDenyBorderStyle', 'buttonDenyBorderColor',
          'buttonDenyBorderRadius', 'buttonDenyPadding', 'buttonDenyBoxShadow',
        ],
        buttonAllow: [
          'buttonAllowBackgroundColor', 'buttonAllowColor',
          'buttonAllowFontSize', 'buttonAllowFontWeight',
          'buttonAllowBorderWidth', 'buttonAllowBorderStyle', 'buttonAllowBorderColor',
          'buttonAllowBorderRadius', 'buttonAllowPadding', 'buttonAllowBoxShadow',
        ],
      },
    };
  },
  computed: {
    vertical: {
      get() {
        if (this.styleData.top && this.styleData.top !== 'auto') return 'top';
        return 'bottom';
      },
      set(val) {
        if (val === 'top') {
          this.updateFields({ top: '10px', bottom: 'auto' });
        } else {
          this.updateFields({ top: 'auto', bottom: '10px' });
        }
      },
    },
    spVertical: {
      get() {
        if (this.styleData.spTop && this.styleData.spTop !== 'auto') return 'top';
        return 'bottom';
      },
      set(val) {
        if (val === 'top') {
          this.updateFields({ spTop: '0px', spBottom: 'auto' });
        } else {
          this.updateFields({ spTop: 'auto', spBottom: '0px' });
        }
      },
    },
    horizontal: {
      get() {
        if (this.styleData.translate === '-50% 0') return 'center';
        const left = this.styleData.left;
        if (left && left !== 'auto') return 'left';
        return 'right';
      },
      set(val) {
        if (val === 'left') {
          this.updateFields({ left: '10px', right: 'auto', translate: '' });
        } else if (val === 'center') {
          // SDK の translate CSS 変数を活用した水平中央寄せ(幅に非依存)
          this.updateFields({
            left: '50%',
            right: 'auto',
            translate: '-50% 0',
          });
        } else {
          this.updateFields({ left: 'auto', right: '10px', translate: '' });
        }
      },
    },
    hasBoxShadow: {
      get() {
        return this.styleData.boxShadow !== 'none';
      },
      set(val) {
        if (val) {
          // あり → styleData から削除して CSS 初期値に戻す
          this.updateFields({ boxShadow: '' });
        } else {
          // なし → 'none' を出力
          this.updateFields({ boxShadow: 'none' });
        }
      },
    },
    hasButtonDenyBoxShadow: {
      get() {
        const v = this.styleData.buttonDenyBoxShadow;
        return !!v && v !== 'none';
      },
      set(val) {
        if (val) {
          // あり → プリセット影を出力
          this.updateFields({ buttonDenyBoxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)' });
        } else {
          // なし → styleData から削除(CSS 初期値 'none')
          this.updateFields({ buttonDenyBoxShadow: '' });
        }
      },
    },
    hasButtonAllowBoxShadow: {
      get() {
        const v = this.styleData.buttonAllowBoxShadow;
        return !!v && v !== 'none';
      },
      set(val) {
        if (val) {
          this.updateFields({ buttonAllowBoxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)' });
        } else {
          this.updateFields({ buttonAllowBoxShadow: '' });
        }
      },
    },
  },
  methods: {
    getRaw(field) {
      if (this.styleData[field] !== undefined && this.styleData[field] !== '') {
        return this.styleData[field];
      }
      return STYLE_DEFAULTS[field] || '';
    },
    setRaw(field, value) {
      let toSet = value;
      // 位置系以外で、CSS 初期値と一致する場合は style から削除
      if (!POSITION_FIELDS.includes(field) && value !== '' && value === STYLE_DEFAULTS[field]) {
        toSet = '';
      }
      this.updateFields({ [field]: toSet });
    },
    getPx(field) {
      const raw = this.getRaw(field);
      if (!raw) return '';
      const num = parseFloat(raw);
      return isNaN(num) ? '' : num;
    },
    setPx(field, value) {
      if (value === '' || value === null || value === undefined) {
        this.setRaw(field, '');
      } else {
        this.setRaw(field, `${value}px`);
      }
    },
    onBorderWidthChange(widthField, styleField, colorField, value) {
      const updates = {};
      // Width の処理(setRaw 相当のロジックを updates に集約)
      const strValue = value === '' || value === null || value === undefined ? '' : `${value}px`;
      if (strValue !== '' && strValue === STYLE_DEFAULTS[widthField]) {
        updates[widthField] = '';
      } else {
        updates[widthField] = strValue;
      }
      const numValue = parseFloat(value || 0);
      const prevWidth = parseFloat(this.getRaw(widthField)) || 0;
      if (numValue < 1) {
        // 幅を 0 に戻す時: 現在の色・スタイルを stash に退避してから styleData から削除
        const currentStyle = this.getRaw(styleField);
        const currentColor = this.getRaw(colorField);
        if (currentStyle && currentStyle !== STYLE_DEFAULTS[styleField]) {
          this.borderStash[styleField] = currentStyle;
        }
        if (currentColor && currentColor !== STYLE_DEFAULTS[colorField]) {
          this.borderStash[colorField] = currentColor;
        }
        updates[styleField] = '';
        updates[colorField] = '';
      } else if (prevWidth < 1) {
        // 0 → 1 以上に戻す時: stash に前回値があれば復元、なければ初期値(黒・実線)
        const stashedStyle = this.borderStash[styleField];
        const stashedColor = this.borderStash[colorField];
        if (!this.getRaw(styleField)) {
          updates[styleField] = stashedStyle || 'solid';
        }
        if (!this.getRaw(colorField) || this.getRaw(colorField) === 'transparent') {
          updates[colorField] = stashedColor || '#000000';
        }
        // 復元後は stash をクリア
        delete this.borderStash[styleField];
        delete this.borderStash[colorField];
      }
      this.updateFields(updates);
    },
    updateFields(updates) {
      const merged = { ...this.styleData };
      for (const [key, value] of Object.entries(updates)) {
        if (value === '' || value === null || value === undefined) {
          delete merged[key];
        } else {
          merged[key] = value;
        }
      }
      this.$emit('update:styleData', merged);
    },
    onReset() {
      this.isResetConfirmOpen = true;
    },
    closeResetConfirm() {
      this.isResetConfirmOpen = false;
    },
    confirmReset() {
      this.$emit('update:styleData', {});
      // 全体リセット時は borderStash も全破棄(残っていると次回のボーダー幅復元時に古い値が戻る)
      this.borderStash = {};
      this.isResetConfirmOpen = false;
    },
    resetSection(fields) {
      const updates = {};
      fields.forEach(f => { updates[f] = ''; });
      // セクション内のボーダー stash も破棄(borderStyle/borderColor および *BorderStyle/*BorderColor)
      fields
        .filter(f => f === 'borderStyle'
          || f === 'borderColor'
          || f.endsWith('BorderStyle')
          || f.endsWith('BorderColor'))
        .forEach(f => { delete this.borderStash[f]; });
      this.updateFields(updates);
    },
  },
};
</script>

<style scoped>
/* 既存モーダル(.c-modal)に準拠。style-settings 用のサイズ・レイアウト調整のみ追加 */
.c-modal--style-settings :deep(.c-modal__content) {
    width: 800px;
    min-width: 400px;
    max-width: 95vw;
}
/* リセット確認モーダルはプレビュー(10001)より上に表示 */
.c-modal--reset-confirm.is-active {
    z-index: 10002;
}
.c-modal--reset-confirm :deep(.c-modal__content) {
    width: 400px;
    max-width: 95vw;
}
.c-modal--reset-confirm :deep(.c-modal__data) {
    text-align: center;
}
.c-modal--style-settings :deep(.c-modal__inner) {
    max-height: 75vh;
    overflow-y: auto;
    padding: 20px 24px;
    background: #f6f8fa;
}
.p-style-dialog__section {
    margin-top: 16px;
    padding: 16px 20px;
    background: #fff;
    border: 1px solid #d0d7de;
    border-radius: 6px;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}
.p-style-dialog__grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 16px;
    align-items: start;
}
.p-style-dialog__grid > .p-style-dialog__section {
    margin-top: 16px;
}
.p-style-dialog__position-columns {
    display: grid;
    grid-template-columns: 1fr 1fr;
    column-gap: 16px;
    align-items: start;
}
@media (max-width: 640px) {
    .p-style-dialog__grid {
        grid-template-columns: 1fr;
    }
    .p-style-dialog__position-columns {
        grid-template-columns: 1fr;
    }
}
.p-style-dialog__note {
    font-size: 12px;
    color: #888;
}
.p-style-dialog__section-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: 0 0 12px 0;
    padding-bottom: 8px;
    border-bottom: 1px solid #eee;
}
.p-style-dialog__section-header .p-style-dialog__section-title {
    margin: 0;
    padding-bottom: 0;
    border-bottom: none;
}
.p-style-dialog__section-reset {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 24px;
    height: 24px;
    padding: 0;
    background: transparent;
    border: none;
    border-radius: 50%;
    cursor: pointer;
    color: #999;
    font-size: 18px;
    line-height: 1;
    transition: background-color .15s ease, color .15s ease;
}
.p-style-dialog__section-reset:hover {
    background: #eaeef2;
    color: #24292f;
}
.p-style-dialog__section-title {
    margin: 0 0 12px 0;
    padding-bottom: 8px;
    font-size: 15px;
    font-weight: bold;
    color: #333;
    text-align: left;
    border-bottom: 1px solid #eee;
}
.p-style-dialog__subsection-title {
    margin: 12px 0 6px 0;
    padding-bottom: 4px;
    font-size: 12px;
    font-weight: bold;
    color: #666;
    text-align: left;
    border-bottom: 1px dashed #eee;
}
.p-style-dialog__subsection-title ~ .p-style-dialog__row {
    padding-left: 12px;
}
.p-style-dialog__subsection-title:first-of-type {
    margin-top: 0;
}
.p-style-dialog__row {
    display: flex;
    align-items: center;
    min-height: 32px;
    margin-bottom: 8px;
}
.p-style-dialog__label {
    width: 120px;
    flex: 0 0 120px;
    font-size: 13px;
    color: #555;
    white-space: nowrap;
}
.p-style-dialog__field {
    display: flex;
    align-items: center;
    gap: 6px;
    flex: 1;
}
.p-style-dialog__input {
    box-sizing: border-box;
    height: 32px;
    padding: 0 8px;
    border: 1px solid #ccc;
    border-radius: 4px;
    font-size: 13px;
    background: #fff;
}
.p-style-dialog__input--small {
    width: 100px;
}
.p-style-dialog__unit {
    font-size: 13px;
    color: #666;
}
.p-style-dialog__radio-list {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    padding: 0;
    margin: 0;
    list-style: none;
}
.p-style-dialog__radio-list .c-radio-list__item {
    margin: 0;
}
.p-style-dialog__radio-list :deep(.c-radio__box-label) {
    font-size: 12px;
}
.p-style-dialog__radio-list :deep(.c-radio__item) {
    width: auto;
}
.p-style-dialog__preview-btn {
    position: absolute;
    top: 44px;
    right: 12px;
    z-index: 10;
    box-sizing: border-box;
    width: 100px !important;
    height: 26px !important;
    padding: 0 10px !important;
    font-size: 12px !important;
    background: #9d9d9d;
    opacity: 0.6;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}
.p-style-dialog__preview-btn .c-btn__text {
    font-size: 12px;
    padding: 0;
    margin: 0;
    line-height: 1;
}
.p-style-dialog__preview-btn.is-preview-active {
    background: #57606a;
}
</style>
